module.exports = __webpack_public_path__ + "media/src/assets/Images/DownloadArrow-b4f38232a278f5534ea523e516ab5b9c.svg";